import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=2d81c3fa&scoped=true&"
import script from "./AuthModal.vue?vue&type=script&lang=js&"
export * from "./AuthModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthModal.vue?vue&type=style&index=0&id=2d81c3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81c3fa",
  null
  
)

export default component.exports